var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLtc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#A5A8A9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5195 33.0528L29.191 44.2845H46.9946C47.2816 44.2852 47.5516 44.4208 47.7236 44.6507C47.8956 44.8805 47.9496 45.1778 47.8693 45.4534L46.3211 50.7867C46.1694 51.3101 45.6896 51.67 45.1446 51.6691H17.9515L22.5495 36.1413L17.4639 37.6895L18.5863 34.0591L23.6796 32.5109L30.1354 10.6977C30.2812 10.1724 30.759 9.80847 31.3042 9.8075H38.1934C38.48 9.80648 38.7505 9.94003 38.9239 10.1682C39.0973 10.3964 39.1536 10.6927 39.0759 10.9686L33.6574 29.4147L38.743 27.8665L37.6516 31.5588L32.5195 33.0528Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLtc);
export default __webpack_public_path__ + "static/media/ltc.8d2c9e99090feaf563ef79d96b005c3e.svg";
export { ForwardRef as ReactComponent };